"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;
exports.save = save;
exports.unpin = unpin;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var _EngagementRecord = _interopRequireDefault(require("customer-data-objects/engagement/EngagementRecord"));

var _MetaAPI = require("crm_data/meta/MetaAPI");

var API = 'engagements/v1/pinned';

var makeURI = function makeURI() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return API + "/" + args.join('/');
};

function fetch(objectType, objectId) {
  var fallback = function fallback() {
    return (0, _ImmutableAPI.get)(makeURI(objectType, objectId), null);
  };

  return (0, _MetaAPI.queueFetch)("PINNED_" + objectType + "_ENGAGEMENT", fallback, {
    objectIds: (0, _defineProperty2.default)({}, objectType, parseInt(objectId, 10))
  }, _EngagementRecord.default.fromJS);
}

function save(objectType, objectId, engagementId) {
  return (0, _ImmutableAPI.put)(makeURI(objectType, objectId, engagementId));
}

function unpin(objectType, objectId) {
  return (0, _ImmutableAPI.del)(makeURI(objectType, objectId));
}